module.exports = __webpack_public_path__ + "static/media/we.f5a82487.gltf";